










































import Vue from "vue";
import { locStr } from "@/utilities";
export default Vue.extend({
    name: "MangoFpEditStep",
    props: {
        code: {
            type: String,
        },
        action: {
            type: String,
        },
        state: {
            type: String,
        },
        showLoader: {
            type: Boolean,
        },
    },
    data() {
        return {
            code4Edit: this.code || "",
            action4Edit: this.action || "",
            state4Edit: this.state || "",
            absolute: true,
        };
    },
    mounted() {
        let focusedEdit = this.$refs.stateField as HTMLInputElement;
        if (!this.code) {
            focusedEdit = this.$refs.codeField as HTMLInputElement;
        }

        if (focusedEdit) {
            focusedEdit.focus();
        }
    },
    methods: {
        locStr: function(key: string): string {
            return locStr(key);
        },
        saveData() {
            this.$emit("add", {
                code: this.code4Edit.toUpperCase(),
                action: this.action4Edit,
                state: this.state4Edit,
            });
        },
        cancelSaving() {
            this.code4Edit = this.code;
            this.action4Edit = this.action;
            this.state4Edit = this.state;
            this.$emit("close");
        },
    },
});
